var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 61,
    viewBox: "0 0 85 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 30.5,
    r: 30,
    fill: "#F7F1EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_87498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 36C44 37.5913 44.6321 39.1174 45.7574 40.2426C46.8826 41.3679 48.4087 42 50 42C51.5913 42 53.1174 41.3679 54.2426 40.2426C55.3679 39.1174 56 37.5913 56 36C56 34.4087 55.3679 32.8826 54.2426 31.7574C53.1174 30.6321 51.5913 30 50 30C48.4087 30 46.8826 30.6321 45.7574 31.7574C44.6321 32.8826 44 34.4087 44 36Z",
    stroke: "#E0CCB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7581 40.2421L54.2431 31.7571",
    stroke: "#E0CCB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 35H33C33.0134 33.8575 33.2513 32.7288 33.7 31.678C34.19 30.697 36.239 30.017 38.811 29.065C39.506 28.807 39.392 26.991 39.084 26.652C38.5926 26.121 38.2192 25.492 37.9882 24.8064C37.7573 24.1208 37.674 23.3941 37.744 22.674C37.6999 22.2156 37.7507 21.7529 37.8933 21.315C38.0358 20.877 38.267 20.4731 38.5725 20.1284C38.8779 19.7838 39.2511 19.5057 39.6688 19.3115C40.0864 19.1174 40.5396 19.0113 41 19C41.4604 19.0113 41.9136 19.1174 42.3312 19.3115C42.7489 19.5057 43.1221 19.7838 43.4275 20.1284C43.733 20.4731 43.9642 20.877 44.1067 21.315C44.2493 21.7529 44.3001 22.2156 44.256 22.674C44.3265 23.3938 44.2439 24.1203 44.0136 24.8059C43.7834 25.4915 43.4107 26.1207 42.92 26.652C42.612 26.991 42.498 28.807 43.193 29.065L44.5 29.546",
    stroke: "#E0CCB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 22.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 33.5,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 33.5,
    width: 9,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 33.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 33.5,
    width: 6,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 22.5,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_87498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(32.5 18.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawSummary);
export default __webpack_public_path__ + "static/media/withdraw-summary.ed525ba6510699126ffd644be75aaf51.svg";
export { ForwardRef as ReactComponent };